import cn from 'classnames';
import type { MouseEvent } from 'react';
import ArrowNarrowLeftIcon from './icons/ArrowNarrowLeftIcon';
import ArrowNarrowRightIcon from './icons/ArrowNarrowRightIcon';

type Props = {
  disabled?: boolean;
  left?: boolean;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  loop: boolean;
  type: string;
};

export default function ButtonNavSwiper({
  disabled,
  loop,
  left = false,
  onClick,
  className,
  type = '',
}: Props) {
  return (
    <button
      onClick={onClick}
      aria-label="button"
      className={cn(
        ' desktop:enabled:hover:bg-white desktop:enabled:active:bg-white arrow border-neutral-60 group flex h-10 w-10 items-center justify-center rounded-full bg-[#F2F4F8] disabled:opacity-50',
        {
          'arrow--left': left,
          'arrow--right': !left,
          'arrow--disabled hidden': disabled && !loop,
          'border-2': type !== 'banner',
          'opacity-50': type === 'banner',
          '!left-4': left && type == 'banner',
          '!right-4': !left && type == 'banner',
        },
        disabled,
        className
      )}
    >
      {!left ? (
        <ArrowNarrowRightIcon className="fill-neutral-60" />
      ) : (
        <ArrowNarrowLeftIcon className="fill-neutral-60" />
      )}
    </button>
  );
}
